import { render } from "./AdministratorAccess.vue?vue&type=template&id=68ffc9fb&scoped=true"
import script from "./AdministratorAccess.vue?vue&type=script&lang=js"
export * from "./AdministratorAccess.vue?vue&type=script&lang=js"

import "./AdministratorAccess.vue?vue&type=style&index=0&id=68ffc9fb&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ffc9fb"]])

export default __exports__